/* eslint-disable react/prop-types */
import React, { useState } from "react";
import facebook from "../../assets/images/facebook.svg";
import instagram from "../../assets/images/instagram.svg";
import logo from "../../assets/images/logo-2.webp";

import "./style.scss";
import { useTranslation } from "react-i18next";

const Navigation = ({ lang }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [openTravel, setOpenTravel] = useState(false);
  const [openInfo, setOpenInfo] = useState(false);
  return (
    <>
      <header>
        <div className="border-b border-gray-300">
          <div className="flex justify-between container items-center h-[64px] lg:h-[58px] lg:px-0 pr-0">
            <div className="flex items-center gap-8 lg:hidden">
              <div
                className="grid gap-[7px] w-5 ml-2"
                onClick={() => setOpen(true)}
              >
                <span className="w-full h-[1px] bg-black"></span>
                <span className="w-full h-[1px] bg-black"></span>
                <span className="w-full h-[1px] bg-black"></span>
              </div>
              <a href={`https://www.okayama-japan.jp/${lang}`}>
                <img src={logo} className="h-[43px]" alt="" />
              </a>
            </div>
            <div className="hidden !gap-5 lg:flex">
              <div>
                <a
                  href="https://www.facebook.com/okayama.eng/"
                  rel="noreferrer"
                  target="_blank"
                >
                  <img src={facebook} className="w-4 h-4" alt="" />
                </a>
              </div>
              <div>
                <a
                  href="https://www.instagram.com/?hl=ja"
                  rel="noreferrer"
                  target="_blank"
                >
                  <img src={instagram} className="w-4 h-4" alt="" />
                </a>
              </div>
            </div>
            <div className="flex justify-end items-center gap-8">
              <div className="hidden lg:block">
                <input
                  type="text"
                  name="search"
                  id="search_input"
                  value=""
                  className="hidden"
                />
                <div
                  id="search_btn"
                  className="flex items-center justify-center h-9 w-9 rounded-full border-gray-400 border bg-gray-100"
                >
                  <span className="material-symbols-outlined">search</span>
                </div>
              </div>
              <a
                href={`https://www.txjcrm.com/okayama/reservation?lang=${lang}`}
                className="bg-twprimary text-white flex justify-center items-center h-[64px] w-[64px]  lg:h-[58px] p-0 lg:w-fit lg:!p-4 !gap-2"
              >
                <span className="material-icons text-xl">local_activity</span>
                <span className="hidden lg:block">{t("reservation")}</span>
              </a>
            </div>
          </div>
        </div>
        <div className="border-b border-gray-300 hidden lg:block">
          <div className="flex justify-between items-center container lg:px-0">
            <a href={`https://www.okayama-japan.jp/${lang}`}>
              <img
                src={logo}
                className="h-[90px] w-auto object-contain"
                alt=""
              />
            </a>
            <div>
              <ul className="flex items-center h-[98px] justify-end">
                <li className="h-[98px] w-[128px] text-[15px] px-[5px] flex relative items-center border-l border-gray-300 text-center justify-center flex-col">
                  <a href={`https://www.okayama-japan.jp/${lang}/abouts`}>
                    {t("about_okayama")}
                  </a>
                </li>
                <li className="h-[98px] w-[128px] text-[15px] px-[5px] flex relative items-center border-l border-gray-300 text-center justify-center flex-col">
                  <a href={`https://www.okayama-japan.jp/${lang}/article`}>
                    {t("okatabi")}
                  </a>
                </li>
                <li className="h-[98px] w-[128px] text-[15px] px-[5px] flex relative items-center border-l border-gray-300 text-center justify-center flex-col">
                  <a href={`https://www.okayama-japan.jp/${lang}/feature`}>
                    {t("specialties")}
                  </a>
                </li>
                <li
                  onClick={() => setOpenTravel(!openTravel)}
                  className="cursor-pointer h-[98px] w-[128px] text-[15px] px-[5px] flex relative items-center border-l border-gray-300 text-center justify-center flex-col"
                >
                  <div>{t("travel_genre")}</div>
                  <div className="arrow"></div>
                  <div
                    className={`${
                      openTravel ? "block" : "hidden"
                    } bg-white border border-gray-300 absolute top-[100px] w-[240px] max-h-[200px] overflow-auto z-10`}
                  >
                    <ul>
                      <li className="text-left py-1.5 px-4 min-h-[50px] flex items-center cursor-pointer">
                        <a
                          href={`https://www.okayama-japan.jp/${lang}/history`}
                        >
                          {t("history")}
                        </a>
                      </li>

                      <li className="text-left py-1.5 px-4 min-h-[50px] flex items-center cursor-pointer">
                        <a href={`https://www.okayama-japan.jp/${lang}/nature`}>
                          {t("nature")}
                        </a>
                      </li>

                      <li className="text-left py-1.5 px-4 min-h-[50px] flex items-center cursor-pointer">
                        <a
                          href={`https://www.okayama-japan.jp/${lang}/townscape`}
                        >
                          {t("townscape")}
                        </a>
                      </li>

                      <li className="text-left py-1.5 px-4 min-h-[50px] flex items-center cursor-pointer">
                        <a href={`https://www.okayama-japan.jp/${lang}/sakura`}>
                          {t("cherry")}
                        </a>
                      </li>

                      <li className="text-left py-1.5 px-4 min-h-[50px] flex items-center cursor-pointer">
                        <a
                          href={`https://www.okayama-japan.jp/${lang}/autumnleaves`}
                        >
                          {t("autumn")}
                        </a>
                      </li>

                      <li className="text-left py-1.5 px-4 min-h-[50px] flex items-center cursor-pointer">
                        <a href={`https://www.okayama-japan.jp/${lang}/art`}>
                          {t("art")}
                        </a>
                      </li>

                      <li className="text-left py-1.5 px-4 min-h-[50px] flex items-center cursor-pointer">
                        <a
                          href={`https://www.okayama-japan.jp/${lang}/experience`}
                        >
                          {t("experience")}
                        </a>
                      </li>

                      <li className="text-left py-1.5 px-4 min-h-[50px] flex items-center cursor-pointer">
                        <a
                          href={`https://www.okayama-japan.jp/${lang}/gourment`}
                        >
                          {t("gourmet")}
                        </a>
                      </li>

                      <li className="text-left py-1.5 px-4 min-h-[50px] flex items-center cursor-pointer">
                        <a href={`https://www.okayama-japan.jp/${lang}/spa`}>
                          {t("onsen")}
                        </a>
                      </li>

                      <li className="text-left py-1.5 px-4 min-h-[50px] flex items-center cursor-pointer">
                        <a
                          href={`https://www.okayama-japan.jp/${lang}/shopping`}
                        >
                          {t("shopping")}
                        </a>
                      </li>

                      <li className="text-left py-1.5 px-4 min-h-[50px] flex items-center cursor-pointer">
                        <a
                          href={`https://www.okayama-japan.jp/${lang}/souvenirs`}
                        >
                          {t("souvenirs")}
                        </a>
                      </li>

                      <li className="text-left py-1.5 px-4 min-h-[50px] flex items-center cursor-pointer">
                        <a
                          href={`https://www.okayama-japan.jp/${lang}/touristoffice`}
                        >
                          {t("tourist_info")}
                        </a>
                      </li>

                      <li className="text-left py-1.5 px-4 min-h-[50px] flex items-center cursor-pointer">
                        <a
                          href={`https://www.okayama-japan.jp/${lang}/recommended-course`}
                        >
                          {t("model_course")}
                        </a>
                      </li>

                      <li className="text-left py-1.5 px-4 min-h-[50px] flex items-center cursor-pointer">
                        <a href={`https://www.okayama-japan.jp/${lang}/event`}>
                          {t("event")}
                        </a>
                      </li>
                    </ul>
                  </div>
                </li>

                <li className="h-[98px] w-[128px] text-[15px] px-[5px] flex relative items-center border-l border-gray-300 text-center justify-center flex-col">
                  <a href={`https://www.okayama-japan.jp/${lang}/course`}>
                    {t("model_course")}
                  </a>
                </li>
                <li
                  onClick={() => setOpenInfo(!openInfo)}
                  className="cursor-pointer h-[98px] w-[128px] text-[15px] !px-5 flex relative items-center border-x border-gray-300 text-center justify-center flex-col"
                >
                  <div>{t("information")}</div>
                  <div className="arrow"></div>
                  <div
                    className={`${
                      openInfo ? "block" : "hidden"
                    } bg-white border border-gray-300 absolute top-[100px] w-[240px] max-h-[200px] overflow-auto z-10`}
                  >
                    <ul>
                      <li className="text-left py-1.5 px-4 min-h-[50px] flex items-center cursor-pointer">
                        <a href={`https://www.okayama-japan.jp/${lang}/access`}>
                          {t("access")}
                        </a>
                      </li>

                      <li className="text-left py-1.5 px-4 min-h-[50px] flex items-center cursor-pointer">
                        <a
                          href={`https://www.okayama-japan.jp/${lang}/okayama-access-guide`}
                        >
                          {t("access_okayama")}
                        </a>
                      </li>

                      <li className="text-left py-1.5 px-4 min-h-[50px] flex items-center cursor-pointer">
                        <a href={`https://www.okayama-japan.jp/${lang}/faq`}>
                          {t("faq")}
                        </a>
                      </li>

                      <li className="text-left py-1.5 px-4 min-h-[50px] flex items-center cursor-pointer">
                        <a
                          href={`https://www.okayama-japan.jp/${lang}/interpreter`}
                        >
                          {t("national_govt")}
                        </a>
                      </li>

                      <li className="text-left py-1.5 px-4 min-h-[50px] flex items-center cursor-pointer">
                        <a href={`https://www.okayama-japan.jp/${lang}/accept`}>
                          {t("okayama_prefect")}
                        </a>
                      </li>

                      <li className="text-left py-1.5 px-4 min-h-[50px] flex items-center cursor-pointer">
                        <a href={`https://www.okayama-japan.jp/${lang}/links`}>
                          {t("safety_info")}
                        </a>
                      </li>

                      <li className="text-left py-1.5 px-4 min-h-[50px] flex items-center cursor-pointer">
                        <a
                          href={`https://www.okayama-japan.jp/${lang}/timelapse`}
                        >
                          {t("time_lapse")}
                        </a>
                      </li>

                      <li className="text-left py-1.5 px-4 min-h-[50px] flex items-center cursor-pointer">
                        <a
                          href={`https://www.okayama-japan.jp/${lang}/guidemap`}
                        >
                          {t("brochure")}
                        </a>
                      </li>

                      <li className="text-left py-1.5 px-4 min-h-[50px] flex items-center cursor-pointer">
                        <a
                          href={`https://www.okayama-japan.jp/${lang}/privacy`}
                        >
                          {t("privacy_policy")}
                        </a>
                      </li>
                    </ul>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </header>
      <div
        className={`bg-black bg-opacity-50 ${
          open ? "visible" : "invisible"
        } fixed left-0 top-0 z-10 w-screen h-screen`}
      ></div>
      <div
        className={`${
          open ? "translate-x-0" : "-translate-x-full"
        } w-[80vw] h-screen bg-white fixed z-30 top-0 left-0 !p-5 !pt-1 transition duration-700 overflow-auto`}
      >
        <div className="flex justify-end mb-2" onClick={() => setOpen(false)}>
          <span className="material-icons text-3xl font-light">close</span>
        </div>
        <div className="relative !mb-6">
          <input
            type="text"
            className="border rounded-lg border-gray-200 w-full p-2"
          />
          <div className="absolute right-2 top-1/2 -translate-y-1/2">
            <span className="material-symbols-outlined text-[30px]">
              search
            </span>
          </div>
        </div>
        <ul className="grid gap-[35px]">
          <li className="flex relative items-center">
            <a href={`https://www.okayama-japan.jp/${lang}/abouts`}>
              {t("about_okayama")}
            </a>
          </li>
          <li className="flex relative items-center">
            <a href={`https://www.okayama-japan.jp/${lang}/article`}>
              {t("okatabi")}
            </a>
          </li>
          <li className="flex relative items-center">
            <a href={`https://www.okayama-japan.jp/${lang}/feature`}>
              {t("specialties")}
            </a>
          </li>
          <div>
            <li
              className="flex items-center cursor-pointer"
              onClick={() => setOpenTravel(!openTravel)}
            >
              <div>{t("travel_genre")}</div>
              <div className="arrow !static ml-3"></div>
            </li>
            <div
              className={`${
                openTravel
                  ? "max-h-[1200px] opacity-100 visible mt-4"
                  : "max-h-0 opacity-0 invisible mt-0"
              } bg-[#fcfbf8] transition-all duration-500`}
            >
              <ul>
                <li className="text-left py-1.5 px-4 min-h-[50px] flex items-center cursor-pointer">
                  <a href={`https://www.okayama-japan.jp/${lang}/history`}>
                    {t("history")}
                  </a>
                </li>

                <li className="text-left py-1.5 px-4 min-h-[50px] flex items-center cursor-pointer">
                  <a href={`https://www.okayama-japan.jp/${lang}/nature`}>
                    {t("nature")}
                  </a>
                </li>

                <li className="text-left py-1.5 px-4 min-h-[50px] flex items-center cursor-pointer">
                  <a href={`https://www.okayama-japan.jp/${lang}/townscape`}>
                    {t("townscape")}
                  </a>
                </li>

                <li className="text-left py-1.5 px-4 min-h-[50px] flex items-center cursor-pointer">
                  <a href={`https://www.okayama-japan.jp/${lang}/sakura`}>
                    {t("cherry")}
                  </a>
                </li>

                <li className="text-left py-1.5 px-4 min-h-[50px] flex items-center cursor-pointer">
                  <a href={`https://www.okayama-japan.jp/${lang}/autumnleaves`}>
                    {t("autumn")}
                  </a>
                </li>

                <li className="text-left py-1.5 px-4 min-h-[50px] flex items-center cursor-pointer">
                  <a
                    href={`https://www.okayama-japan.jp/${lang}/art">{t("art")}`}
                  />
                </li>

                <li className="text-left py-1.5 px-4 min-h-[50px] flex items-center cursor-pointer">
                  <a href={`https://www.okayama-japan.jp/${lang}/experience`}>
                    {t("experience")}
                  </a>
                </li>

                <li className="text-left py-1.5 px-4 min-h-[50px] flex items-center cursor-pointer">
                  <a href={`https://www.okayama-japan.jp/${lang}/gourment`}>
                    {t("gourmet")}
                  </a>
                </li>

                <li className="text-left py-1.5 px-4 min-h-[50px] flex items-center cursor-pointer">
                  <a
                    href={`https://www.okayama-japan.jp/${lang}/spa">{t("onsen")}`}
                  />
                </li>

                <li className="text-left py-1.5 px-4 min-h-[50px] flex items-center cursor-pointer">
                  <a href={`https://www.okayama-japan.jp/${lang}/shopping`}>
                    {t("shopping")}
                  </a>
                </li>

                <li className="text-left py-1.5 px-4 min-h-[50px] flex items-center cursor-pointer">
                  <a href={`https://www.okayama-japan.jp/${lang}/souvenirs`}>
                    {t("souvenirs")}
                  </a>
                </li>

                <li className="text-left py-1.5 px-4 min-h-[50px] flex items-center cursor-pointer">
                  <a
                    href={`https://www.okayama-japan.jp/${lang}/touristoffice`}
                  >
                    {t("tourist_info")}
                  </a>
                </li>

                <li className="text-left py-1.5 px-4 min-h-[50px] flex items-center cursor-pointer">
                  <a
                    href={`https://www.okayama-japan.jp/${lang}/recommended-course`}
                  >
                    {t("model_course")}
                  </a>
                </li>

                <li className="text-left py-1.5 px-4 min-h-[50px] flex items-center cursor-pointer">
                  <a href={`https://www.okayama-japan.jp/${lang}/event`}>
                    {t("event")}
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <li className="flex relative items-center">
            <a href={`https://www.okayama-japan.jp/${lang}/article`}>
              {t("model_course")}
            </a>
          </li>
          <div>
            <li
              className="flex items-center"
              onClick={() => setOpenInfo(!openInfo)}
            >
              <div>{t("information")}</div>
              <div className="arrow !static ml-3"></div>
            </li>
            <div
              className={`${
                openInfo
                  ? "max-h-[1200px] opacity-100 visible mt-4"
                  : "max-h-0 opacity-0 invisible mt-0"
              } bg-[#fcfbf8] transition-all duration-500`}
            >
              <ul>
                <li className="text-left py-1.5 px-4 min-h-[50px] flex items-center cursor-pointer">
                  <a href={`https://www.okayama-japan.jp/${lang}/access`}>
                    {t("access")}
                  </a>
                </li>

                <li className="text-left py-1.5 px-4 min-h-[50px] flex items-center cursor-pointer">
                  <a
                    href={`https://www.okayama-japan.jp/${lang}/okayama-access-guide`}
                  >
                    {t("access_okayama")}
                  </a>
                </li>

                <li className="text-left py-1.5 px-4 min-h-[50px] flex items-center cursor-pointer">
                  <a
                    href={`https://www.okayama-japan.jp/${lang}/faq">{t("faq")}`}
                  />
                </li>

                <li className="text-left py-1.5 px-4 min-h-[50px] flex items-center cursor-pointer">
                  <a href={`https://www.okayama-japan.jp/${lang}/interpreter`}>
                    {t("national_govt")}
                  </a>
                </li>

                <li className="text-left py-1.5 px-4 min-h-[50px] flex items-center cursor-pointer">
                  <a href={`https://www.okayama-japan.jp/${lang}/accept`}>
                    {t("okayama_prefect")}
                  </a>
                </li>

                <li className="text-left py-1.5 px-4 min-h-[50px] flex items-center cursor-pointer">
                  <a href={`https://www.okayama-japan.jp/${lang}/links`}>
                    {t("safety_info")}
                  </a>
                </li>

                <li className="text-left py-1.5 px-4 min-h-[50px] flex items-center cursor-pointer">
                  <a href={`https://www.okayama-japan.jp/${lang}/timelapse`}>
                    {t("time_lapse")}
                  </a>
                </li>

                <li className="text-left py-1.5 px-4 min-h-[50px] flex items-center cursor-pointer">
                  <a href={`https://www.okayama-japan.jp/${lang}/guidemap`}>
                    {t("brochure")}
                  </a>
                </li>

                <li className="text-left py-1.5 px-4 min-h-[50px] flex items-center cursor-pointer">
                  <a href={`https://www.okayama-japan.jp/${lang}/privacy`}>
                    {t("privacy_policy")}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </ul>
      </div>
    </>
  );
};

export default Navigation;
